// Taux de TVA proposés à l'inscription d'un client, partagés entre le formulaire public
// (src/components/Public/ClientRegistrationForm.tsx) et le serveur (functions/api/[[path]].js).
//
// Ce sont des taux LÉGAUX de base, proposés à titre d'aide : le client coche ceux qui s'appliquent à son activité
// et confirme qu'ils sont justes. Il n'y a PAS de saisie libre, et L'IAmani ne vérifie pas ces taux à la validation
// du dossier : le client reste seul responsable de la TVA qu'il applique (CGU, article 12).
// Les taux changent avec la loi : c'est ici, et nulle part ailleurs, qu'il faut les mettre à jour.
export const TAUX_TVA_LEGAUX = [20, 10, 5.5, 2.1];

// Cochés d'office selon le type d'établissement (le client peut les changer).
export const TAUX_TVA_PAR_DEFAUT = {
    restauration: [10, 20],
    hotellerie: [10, 20],
    prestation: [20],
    fournisseur: [5.5, 20],
};

export const tauxParDefaut = (clientType) => [...(TAUX_TVA_PAR_DEFAUT[clientType] || TAUX_TVA_PAR_DEFAUT.restauration)];

/**
 * Taux demandés par un client, ramenés à une liste valide : uniquement des taux légaux, sans doublon, triés.
 * Renvoie null si la liste est vide ou contient autre chose qu'un taux légal (le serveur refuse alors la demande).
 */
export const tauxValides = (rates) => {
    if (!Array.isArray(rates) || rates.length === 0) return null;
    const nombres = rates.map((r) => Number(r));
    if (nombres.some((n) => !TAUX_TVA_LEGAUX.includes(n))) return null;
    return [...new Set(nombres)].sort((a, b) => a - b);
};
